<template>
  <ul class="first-menu" v-if="firstLevelMenuList.length > 0">
    <li :class="currentFirstMenuId === 'home' ? 'actived' : ''" @click="goHome">
      <i :class="'iconfont ' + (currentFirstMenuId === 'home' ? 'jianhao' : 'jiahao')"></i>
      <span>网站首页</span>
    </li>

    <li
      v-for="(item, index) in firstLevelMenuList.slice(0, -2)"
      :key="index"
      v-show="item.id !== onlineService"
      :class="currentFirstMenuId === item.id ? 'actived' : ''"
      @click="clickFirstMenu(item, clickTag)"
    >
      <i :class="'iconfont ' + (currentFirstMenuId === item.id ? 'jianhao' : 'jiahao')"></i>
      <span>{{ item.name }}</span>
    </li>

    <li
      v-for="(item, index) in firstLevelMenuList"
      :key="'online' + index"
      v-show="item.id === onlineService"
      :class="currentFirstMenuId === 'online' ? 'actived' : ''"
      @click="goOnline"
    >
      <i :class="'iconfont ' + (currentFirstMenuId === 'online' ? 'jianhao' : 'jiahao')"></i>
      <span>{{ item.name }}</span>
    </li>

    <li :class="currentFirstMenuId === 'contact' ? 'actived' : ''" @click="goContact">
      <i :class="'iconfont ' + (currentFirstMenuId === 'contact' ? 'jianhao' : 'jiahao')"></i>
      <span>联系我们</span>
    </li>
  </ul>

  <p v-else class="mytip">当前暂无内容~</p>
</template>

<script>
import codes from '@/api/codes';
import { configureParams } from '@/assets/js/configureParams';

export default {
  name: 'FirstMenu',
  data() {
    return {
      firstLevelMenuList: [], // 一级栏目导航列表
      clickTag: codes.MENU, // 标记点击的是菜单
      onlineService: codes.ONLINE_SERVICE, // 在线服务模块
    };
  },
  mounted() {
    this.initFirstLevelMenu();
  },
  computed: {
    currentFirstMenuId() {
      if (this.$route.name === 'Contact') {
        return 'contact';
      } else if (this.$route.name === 'ServiceOnline') {
        return 'online';
      } else if (this.$route.name === 'Law') {
        return 'law';
      } else {
        if (this.$route.query.first) {
          return parseInt(this.$route.query.first, 10);
        } else {
          return 'home';
        }
      }
    },
  },
  methods: {
    // 获取一级栏目导航
    initFirstLevelMenu() {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
      };
      this.$api.getFirstLevelMenu(replacement).then((data) => {
        this.firstLevelMenuList = data;
      });
    },

    // 点击一级菜单
    clickFirstMenu(menuData, clickTag) {
      // 获取栏目的菜单结构(每层菜单中的第一个)
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        menuId: menuData.id,
      };
      this.$api.getMenuLevels(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, menuData, clickTag),
        });
      });
    },

    goHome() {
      this.$router.push('/home');
    },

    goContact() {
      this.$router.push('/contact');
    },

    goOnline() {
      this.$router.push('/online');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/common.scss';

.mytip {
  height: calc-width(60vw);
  line-height: calc-width(60vw);
  color: #a0a0a0;
  text-align: center;
  background: #f0f0f0;
}

ul.first-menu {
  padding: 0 0 calc-width(15vw) calc-width(15vw);
  display: flex;
  flex-wrap: wrap;
  background: $home-background-color;
  box-sizing: border-box;

  li.actived span {
    color: $primary-color !important;
  }

  li {
    margin: calc-width(15vw) calc-width(15vw) 0 0;
    display: flex;
    align-items: center;
    height: calc-width(15vw);

    i {
      font-size: calc-width(10vw);
      color: #115fad;
      font-weight: 700;
      margin-right: calc-width(2vw);
    }

    span {
      display: inline-block;
      height: calc-width(15vw);
      line-height: calc-width(15vw);
      font-size: calc-width(15vw);
      font-family: SourceHanSansCN-Medium;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FirstMenu.vue